import script from "./SenderReceiverPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./SenderReceiverPreview.vue?vue&type=script&lang=ts&setup=true"

import "./SenderReceiverPreview.vue?vue&type=style&index=0&id=3df650b3&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3df650b3"]])

export default __exports__